/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enable_This_ListInputs */



/**
* | output |
* | --- |
* | "Enable this list" |
*
* @param {Enable_This_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const enable_this_list = /** @type {((inputs?: Enable_This_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enable_This_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer cette liste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Liste aktivieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abilita questo elenco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить этот список")
	if (locale === "es") return /** @type {LocalizedString} */ ("Habilitar esta lista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启用此列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このリストを有効にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस सूची को सक्षम करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ative esta lista")
	return /** @type {LocalizedString} */ ("Enable this list")
});